import React, { useState } from "react";
import { Button, Row, Col, Form, Card, Divider, Tag } from "antd";
import { RedoOutlined, UndoOutlined } from "@ant-design/icons";
import RenderResponseWithAns from "../../../../../common/renderResponseWithAnsChat";
import { questionsVariations } from "../../../../../commonImports/data";
import { checkValidation, getItemValidation } from "../functions";
import GoogleTranslator from "../../../../../common/googleTranslator";
import { getDataFromDbForm, checkConditions } from "../functions";
import { configVariables } from "../../../../../../configs/configs";
import { useEffect } from "react";
import templateFormBgSvg from "../../../../../../assets/templateFormBgSvg.svg";
import bookLogo from "../../../../../../assets/book.png";

const { CheckableTag } = Tag;

const responsiveStyles = {
  translatorContainer: {
    maxWidth: "80%",
    margin: "auto",
    "@media (max-width: 768px)": {
      width: "95%",
    },
  },
  buttonContainer: {
    width: "100%",
    maxWidth: "400px",
    margin: "auto",
    marginTop: "20px",
    marginBottom: "80px",
    display: "flex",
    gap: "10px",
  },
  actionButton: {
    flex: 1,
    minWidth: "100px",
    height: "48px",
    borderRadius: "25px",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "700",
    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.4)",
    lineHeight: "17px",
  },
  saveSubmitButton: {
    borderWidth: "1px",
    borderColor: "#254EDB",
    backgroundColor: "#EBF4FF",
    color: "#254EDB",
  },
  resetButton: {
    borderWidth: "1px",
    borderColor: "#F22C2C",
    backgroundColor: "#FCE0E0",
    color: "#EA0303",
  },
};

const helpTextStyles = `
.help-text-container img {
  max-width: 100% !important; /* Make sure images don't overflow their container */
  height: auto !important; /* Allow height to scale proportionally */
  max-height: 300px !important; /* Limit maximum height */
  object-fit: contain; /* Maintains aspect ratio */
}

@media (max-width: 768px) {
  .help-text-container img {
    max-height: 150px !important; /* Smaller height on tablets */
  }
}

@media (max-width: 480px) {
  .help-text-container img {
    max-height: 100px !important; /* Even smaller height on mobile phones */
  }
}
`;

const DigitalForm = (props) => {
  const { demoData, flag, loading, setflag, form, query, fullWidth } = props;

  const fnGetAllQuestion = () => {
    var allQuestions = [];
    props.demoData &&
      props.demoData.rows &&
      props.demoData.rows.map((row, index) => {
        row.columns.map((col, index) => {
          col.sections.map((section, index) => {
            allQuestions.push(...section.questions);
          });
        });
      });

    return allQuestions;
  };
  return (
    <div id="demo">
          {
            <RenderUi
              {...props}
              demoData={props.demoData}
              allQuestionArr={fnGetAllQuestion()}
            />
          }
        <Form.Item style={{ display: "none" }} name="status"></Form.Item>
        <Form.Item style={{ display: "none" }} name="htmlConsent"></Form.Item>
        <Form.Item style={{ display: "none" }} name="saveOrSubmit"></Form.Item>

        {window.location.pathname !== "/preview" && (
            <div style={responsiveStyles.buttonContainer}>
              {props.status && props.status == "EDIT" && (
                <>
                  {
                    // console.log(props.templateId, "templateiddddd")
                    // templateList.includes(props.templateId) ?
                    <Button
                      style={{
                        ...responsiveStyles.actionButton,
                        ...responsiveStyles.saveSubmitButton,
                      }}
                      block
                      size="large"
                      type="primary"
                      loading={loading}
                      htmlType="submit"
                      onClick={() => {
                        props.form.setFieldsValue({
                          status: "EDIT",
                          saveOrSubmit: "save",
                        });
                      }}
                    >
                      Save
                    </Button>
                    // : null
                  }

                  <Button
                    style={{
                      ...responsiveStyles.actionButton,
                      ...responsiveStyles.saveSubmitButton,
                    }}
                    block
                    size="large"
                    type="primary"
                    loading={loading}
                    htmlType="submit"
                    onClick={() => {
                      var str =
                        document.getElementById("custom-shadowA3").innerHTML;
                      var str2 = `<link href="${configVariables.amplifyUrl}/static/css/13.80e6c6f2.chunk.css" rel="stylesheet"><link href="${configVariables.amplifyUrl}/static/css/main.0cafd1e4.chunk.css" rel="stylesheet">${str}`;
                      props.form.setFieldsValue({
                        status: "EDIT",
                        htmlConsent: str2,
                        saveOrSubmit: "submit",
                      });
                    }}
                  >
                    Submit
                  </Button>

                  <Button
                    style={{
                      ...responsiveStyles.actionButton,
                      ...responsiveStyles.resetButton,
                    }}
                    size="large"
                    block
                    onClick={() => {
                      form.resetFields();
                      setflag(!flag);
                    }}
                  >
                    <UndoOutlined style={{
                      transform: "rotate(180deg)",
                    }} /> Reset
                  </Button>
                </>
              )}
          </div>
        )}
    </div>
  );
};

const RenderUi = (props) => {
  const {
    demoData,
    flag,
    loading,
    setflag,
    form,
    query,
    type,
    allQuestionArr,
  } = props;

  const [selectedTag, setselectedTag] = useState(1);
  const [localState, setLocalState] = useState({});

  const rerenderCustom = () => {
    setLocalState(prev => ({ ...prev, updated: Date.now() }));
  };

  const getMergedFormValues = () => {
    let localValues = localStorage.getItem("userResponse")
      ? JSON.parse(localStorage.getItem("userResponse"))
      : {};
    return { ...form.getFieldsValue(), ...localValues };
  };

  const shouldShowTitle = (conditions) => {
    if (!conditions || conditions.length === 0) return true;
    const values = getMergedFormValues();
    return checkConditions({ conditions }, values) === true;
  };

  const renderQuestionsNested = (quesItem, index) => {
    if (quesItem != null) {
      let itemValidation = getItemValidation(quesItem);
      let flag = checkValidation(itemValidation, query);
      let showLabel =
        quesItem.questionType == "FILL_IN_BLANKS" ||
        quesItem.questionType == "TABLE"
          ? false
          : true;

      if (flag == true) {
        if (quesItem != null && quesItem.conditions == undefined) {
          if (
            quesItem &&
            quesItem.typeValue &&
            quesItem.typeValue == "LONG_TEXT"
          ) {
            return (
              <div
                dangerouslySetInnerHTML={{ __html: quesItem.htmlContent }}
              ></div>
            );
          } else if (
            quesItem &&
            quesItem.typeValue &&
            quesItem.typeValue.includes("subtemplate")
          ) {
            let obj = getDataFromDbForm(quesItem);

            return (
              <RenderUi
                {...props}
                demoData={obj}
                type="subtemplate"
                allQuestionArr={allQuestionArr}
              />
            );
          } else {
            return (
              <>
                {
                  // (quesItem.addPainCalculation == true && !quesItem.conditions || quesItem.questionType == "PAIN_SCORE_QUESTION") ?
                  //     <></> :
                  <>
                    <div style={{ marginBottom: 10 }}>
                      {showLabel == true &&
                        quesItem.questionType !== "PAIN_SCORE_QUESTION" && (
                          <h4 style={{ marginBottom: "10px", fontSize: "16px", fontWeight: "bolder", color:'#00003B' }}>
                            <span style={{ marginRight: "5px", color: "red" }}>
                              {quesItem.isRequired == true ? "*" : null}
                            </span>
                            {/* add a black square before the question title */}
                            <span style={{ marginRight: "5px", fontSize: "10px", color: "#00003B" }}>
                              ■
                            </span>
                            {quesItem.questionTitle}
                            <span
                              style={{ fontSize: "12px", color: "#b3b3b3" }}
                            >
                              {quesItem.isRequired == true ? "(Required)" : ""}
                            </span>
                          </h4>
                        )}
                      {quesItem.helpText && (
                        // <p style={{ color: 'grey', fontSize: 13 }}>{quesItem.helpText}</p>
                        <div
                          className="help-text-container"
                          style={{
                            backgroundColor: "white",
                            padding: "10px 0px",
                            marginBottom: "10px",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: quesItem.helpText,
                          }}
                        ></div>
                      )}

                      <div style={{ flex: 3 }}>
                        {renderQuestion(quesItem, index, allQuestionArr)}
                      </div>
                    </div>
                    <ul>
                      {quesItem.linkedQuestions &&
                        quesItem.linkedQuestions.length > 0 &&
                        quesItem.linkedQuestions.map((a, xindex) => {
                          return renderQuestionsNested(
                            a,
                            xindex,
                            allQuestionArr,
                          );
                        })}
                    </ul>
                  </>
                }
              </>
            );
          }
        } else {
          let localValues = localStorage.getItem("userResponse")
            ? JSON.parse(localStorage.getItem("userResponse"))
            : {};

          let formValues = { ...form.getFieldsValue(), ...localValues };
          let flag = checkConditions(quesItem, formValues);

          if (flag == true || quesItem.addPainCalculation == true) {
            if (
              quesItem &&
              quesItem.typeValue &&
              quesItem.typeValue == "LONG_TEXT"
            ) {
              return (
                <div
                  dangerouslySetInnerHTML={{ __html: quesItem.htmlContent }}
                ></div>
              );
            } else if (
              quesItem &&
              quesItem.typeValue &&
              quesItem.typeValue.includes("subtemplate")
            ) {
              let obj = getDataFromDbForm(quesItem);

              obj.rows.map((a, x) => {
                a.columns.map((b, y) => {
                  b.sections.map((c, z) => {
                    c.questions.map((d, m) => {
                      d.conditions = quesItem.conditions;
                      d.slugValueNew = `${d.slugValue}-${x}-${y}-${z}-${m}-${index}`;
                    });
                  });
                });
              });
              return (
                // <div>subtemplate</div>
                <RenderUi
                  {...props}
                  demoData={obj}
                  type="subtemplate"
                  allQuestionArr={allQuestionArr}
                />
              );
            } else {
              return (
                <>
                  <div>
                    <div style={{ marginBottom: 10 }}>
                      <h4 style={{ marginBottom: 0 }}>
                        <span style={{ marginRight: "5px", color: "red" }}>
                          {quesItem.isRequired == true ? "*" : null}
                        </span>
                        {quesItem.questionTitle}{" "}
                        <span style={{ fontSize: "12px", color: "#b3b3b3" }}>
                          {quesItem.isRequired == true ? "(Required)" : ""}
                        </span>
                      </h4>
                      <p style={{ color: "grey", fontSize: 13 }}>
                        {/* {quesItem.helpText} */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: quesItem.helpText,
                          }}
                        ></div>
                      </p>
                      <div style={{ flex: 3 }}>
                        {renderQuestion(quesItem, index, allQuestionArr)}
                      </div>
                    </div>
                    <ul>
                      {quesItem.linkedQuestions &&
                        quesItem.linkedQuestions.length > 0 &&
                        quesItem.linkedQuestions.map((a, xindex) => {
                          return renderQuestionsNested(
                            a,
                            xindex,
                            allQuestionArr,
                          );
                        })}
                    </ul>
                  </div>
                </>
              );
            }
          }
        }
      }
    }
  };

  const renderQuestion = (item, index) => {
    return (
      <>
        {
          <RenderResponseWithAns
            rerenderCustom={rerenderCustom}
            record={item}
            full={true}
            form={form}
            index={index}
            chat={false}
          />
        }

        {
          // item.addTotalScoreField == true && item.conditions && fnCalculatePainScore(item)
        }

        {
          //  item.questionType == 'PAIN_SCORE_QUESTION' && fnCalculatePainScore(item)
        }
      </>
    );
  };

  const RenderForm = (props) => {
    let data = props.data;

    return data.map((item, index) => {
      return renderQuestionsNested(item, index);
    });
  };

  let pages = [
    {
      count: 1,
      rows: [],
      pageProperties: {},
    },
  ];

  let footer = {
    obj: null,
    index: null,
  };

  let header = {
    obj: null,
    index: null,
  };

  if (demoData) {
    demoData.rows.forEach((rowItem, index) => {
      if (
        rowItem &&
        rowItem.pageProperties &&
        rowItem.pageProperties.pageBreak == true
      ) {
        rowItem.index = index;
        pages[pages.length - 1].rows.push(rowItem);
        pages[pages.length - 1].pageProperties = rowItem.pageProperties;

        let item = pages[pages.length - 1];
        pages.push({
          count: item.count + 1,
          rows: [],
          pageProperties: {},
        });
      } else if (
        rowItem &&
        rowItem.pageProperties &&
        rowItem.pageProperties.isFooter == true
      ) {
        footer = { obj: rowItem, index: index };
      } else if (
        rowItem &&
        rowItem.pageProperties &&
        rowItem.pageProperties.isHeader == true
      ) {
        header = { obj: rowItem, index: index };
      } else {
        rowItem.index = index;
        pages[pages.length - 1].rows.push(rowItem);
      }
    });
    demoData.properties = demoData.properties
      ? demoData.properties
      : {
          showFormTitle: true,
          repeatTitle: true,
          repeatFooter: true,
          repeatHeader: true,
        };
  }

  let footerSpan = 24;
  if (
    footer &&
    footer.obj &&
    footer.obj.columns &&
    footer.obj.columns.length == 2
  ) {
    footerSpan = 12;
  }
  if (
    footer &&
    footer.obj &&
    footer.obj.columns &&
    footer.obj.columns.length == 3
  ) {
    footerSpan = 8;
  }
  if (
    footer &&
    footer.obj &&
    footer.obj.columns &&
    footer.obj.columns.length == 4
  ) {
    footerSpan = 6;
  }

  let headerSpan = 24;
  if (
    header &&
    header.obj &&
    header.obj.columns &&
    header.obj.columns.length == 2
  ) {
    headerSpan = 12;
  }
  if (
    header &&
    header.obj &&
    header.obj.columns &&
    header.obj.columns.length == 3
  ) {
    headerSpan = 8;
  }
  if (
    header &&
    header.obj &&
    header.obj.columns &&
    header.obj.columns.length == 4
  ) {
    headerSpan = 6;
  }

  return (
    <>
      <style>{helpTextStyles}</style>
      {pages.length > 1 && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            width: "fit-content",
            padding: "5px",
            margin: "auto",
          }}
        >
          {pages.map((a, i) => {
            return (
              <CheckableTag
                style={{
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  textAlign: "center",
                }}
                key={a.count}
                checked={selectedTag == i + 1}
                onChange={(checked) => {
                  if (checked == true) {
                    setselectedTag(i + 1);
                  }
                }}
              >
                {a.count}
              </CheckableTag>
            );
          })}
        </div>
      )}

      {pages.map((pageItem, pageIndex) => {
        if (pageItem.rows.length > 0) {
          if (pageIndex + 1 == selectedTag || pages.length == 1) {
            return (
              <Card
                bordered={false}
                className={type != "subtemplate" && "custom-shadow A3"}
                id={"custom-shadowA3"}
                style={{
                  // margin: type === "subtemplate" ? "0" : "auto",
                  margin: "auto",
                  marginBottom: "20px",
                  // width: type === "subtemplate" ? "100%" : "80%",
                  width: "80%",
                  height: type === "subtemplate" ? "auto" : "calc(100vh - 210px)",
                  overflow: type === "subtemplate" ? "visible" : "scroll",
                  backgroundImage: type === "subtemplate" ? "transparent" : `url(${templateFormBgSvg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                bodyStyle={
                  type != "subtemplate"
                    ? { padding: "40px 5%" }
                    : { padding: 0 }
                }
              >
                <div style={{ height: "100%" }}>
                  {demoData &&
                    demoData != null &&
                    demoData.properties &&
                    (demoData.properties.repeatHeader == true ||
                      (demoData.properties.repeatHeader == false &&
                        pageIndex == 0)) &&
                    header != null &&
                    header.obj != null && (
                      <div style={{ marginBottom: "20px" }}>
                        <Row gutter={24}>
                          {header.obj.columns.map(
                            (headerColItem, headerColIndex) => {
                              if (headerColItem.sections) {
                                return (
                                  <Col span={headerSpan}>
                                    <div>
                                      {headerColItem.sections.map((item) => {
                                        if (item.questions.length > 0) {
                                          return (
                                            <div>
                                              <Card
                                                style={{
                                                  marginBottom: 0,
                                                  background: "none",
                                                }}
                                                bordered={false}
                                                bodyStyle={{ padding: "0px" }}
                                              >
                                                <RenderForm
                                                  data={item.questions}
                                                  pagination={false}
                                                />
                                              </Card>
                                            </div>
                                          );
                                        }
                                      })}
                                    </div>
                                  </Col>
                                );
                              }
                            },
                          )}
                        </Row>
                      </div>
                    )}
                  {type != "subtemplate" && (
                        <div style={{display:'flex',justifyContent:'flex-end'}}>
                          <span style={{ fontSize: "10px", color: "grey" }}>
                            Page {"  " + pageItem.count} / {pages.length}
                          </span>
                        </div>
                  )}
                  {type != "subtemplate" &&
                    demoData &&
                    demoData != null &&
                    demoData.properties &&
                    demoData.properties.showFormTitle == true &&
                    (demoData.properties.repeatTitle == true ||
                      (demoData.properties.repeatTitle == false &&
                        pageIndex == 0)) && (
                      <div style={{ marginBottom: 25 }}>
                        <div style={{display:'flex',alignItems:'center'}}>
                          <div style={{width:'60px',height:'60px',borderRadius:'50%',display:'flex',justifyContent:'center',alignItems:'center',boxShadow: '0px 4px 16.8px 0px rgba(0, 0, 0, 0.25)'}}>
                            <img src={bookLogo} alt="logo" style={{width:'50px',height:'50px', objectFit:'contain'}}/>
                          </div>
                        <h1 style={{marginLeft:'10px', fontSize:'20px',fontWeight:'bold', color:'#00003B' }}>
                          {demoData.displayName
                            ? demoData.displayName
                            : demoData.title}
                        </h1>
                        </div>
                        <p style={{ textAlign: "center", marginBottom: 0, color:'#00003B' }}>
                          {demoData.subTitle}
                        </p>
                      </div>
                    )}

                  {demoData != null &&
                    pageItem.rows.length > 0 &&
                    pageItem.rows.map((rowItem) => {
                      if (!shouldShowTitle(rowItem.titleConditions)) {
                        return null;
                      }
                      if (rowItem.columns && rowItem.columns.length > 0) {
                        let span = 24;
                        if (rowItem.columns && rowItem.columns.length == 2) {
                          span = 12;
                        }
                        if (rowItem.columns && rowItem.columns.length == 3) {
                          span = 8;
                        }
                        if (rowItem.columns && rowItem.columns.length == 4) {
                          span = 6;
                        }
                        return (
                          <Row gutter={48}>
                            <Col span={24}>
                              {shouldShowTitle(rowItem.titleConditions) && (
                                <div style={{ marginBottom: 10 }}>
                                  <h2
                                    style={{ marginBottom: 0, color: "#696969" }}
                                  >
                                    {rowItem.title}
                                  </h2>
                                  <p style={{ marginBottom: 0 }}>
                                    {rowItem.subTitle}
                                  </p>
                                </div>
                              )}
                            </Col>

                            {rowItem.columns.map((colItem) => {
                              if (!shouldShowTitle(colItem.titleConditions)) {
                                return null;
                              }
                              if (colItem.sections) {
                                return (
                                  <Col span={span}>
                                    <div style={{ marginBottom: 10 }}>
                                      <h3
                                        style={{
                                          marginBottom: 0,
                                          color: "#00003B",
                                        }}
                                      >
                                        {colItem.title ? colItem.title : null}
                                      </h3>
                                      <p style={{ marginBottom: 0 }}>
                                        {colItem.subTitle}
                                      </p>
                                    </div>
                                    <div>
                                        {colItem.sections.map((item) => {
                                          if (!shouldShowTitle(item.titleConditions)) {
                                            return null;
                                          }
                                          if (item.questions.length > 0) {
                                          return (
                                            <div>
                                              <div style={{ marginBottom: 10,maxWidth:'fit-content' }}>
                                                    <>
                                                      <h3
                                                        style={{
                                                          fontSize:'24px',
                                                          fontWeight:'bold',
                                                          color:'#00003B'
                                                        }}
                                                      >
                                                        {item.title
                                                          ? item.title
                                                          : null}
                                                      </h3>
                                                      <p style={{ marginBottom: 0 }}>
                                                        {item.subTitle}
                                                      </p>
                                                    </>
                                                <div style={{height:'4px',backgroundColor:'#03A096',marginBottom:'10px',width:'100%'}}></div>
                                              </div>

                                              <Card
                                                style={{
                                                  marginBottom: 0,
                                                  background: "none",
                                                }}
                                                bordered={false}
                                                bodyStyle={{ padding: "0px" }}
                                              >
                                                <RenderForm
                                                  data={item.questions}
                                                  pagination={false}
                                                />
                                              </Card>
                                            </div>
                                          );
                                        }
                                      })}
                                    </div>
                                  </Col>
                                );
                              }
                            })}
                          </Row>
                        );
                      }
                    })}
                  {demoData &&
                    demoData != null &&
                    demoData.properties &&
                    (demoData.properties.repeatFooter == true ||
                      (demoData.properties.repeatFooter == false &&
                        pageIndex == pages.length - 1)) &&
                    footer != null &&
                    footer.obj != null && (
                      <div
                        style={{
                          padding: "10px",
                          marginTop: "50px",
                        }}
                      >
                        <Row gutter={24}>
                          {footer.obj.columns.map(
                            (footerColItem, foooterColIndex) => {
                              if (footerColItem.sections) {
                                return (
                                  <Col span={footerSpan}>
                                    <div>
                                      {footerColItem.sections.map((item) => {
                                        if (item.questions.length > 0) {
                                          return (
                                            <div>
                                              <Card
                                                style={{
                                                  marginBottom: 0,
                                                  background: "none",
                                                }}
                                                bordered={false}
                                                bodyStyle={{
                                                  padding: "0px",
                                                  background: "none",
                                                }}
                                              >
                                                <RenderForm
                                                  data={item.questions}
                                                  pagination={false}
                                                />
                                              </Card>
                                            </div>
                                          );
                                        }
                                      })}
                                    </div>
                                  </Col>
                                );
                              }
                            },
                          )}
                        </Row>
                      </div>
                    )}
                </div>
              </Card>
            );
          }
        }
      })}
    </>
  );
};

export default DigitalForm;
